import { api, catchHandler } from '@helpers/axios'
import config from '@config/index'

export function businessAddressDetails (payload) {
  return api()
    .get(`${config.routes.fetchBussiness}/${payload.place_id}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
